import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { faCompass } from '@fortawesome/pro-light-svg-icons/faCompass';
import { TypedMemo } from '../../common/types';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { useUserTokenDecoded } from '../../../redux/slices/appInfo/hooks';
import { PageUnavailable } from './PageUnavailable';
import { notFoundMessages } from './notFoundMessages';

/**
 * The page of an unknown `/app/*` address (QA finding brk-1). A signed-in user gets the app shell
 * and "Go to Home"; a visitor gets "Sign in". Before, an unknown address showed an empty page.
 */
const NotFoundViewComponent: React.FC = () => {
  const intl = useIntl();
  const router = useSMLRouter();
  const isSignedIn = useUserTokenDecoded() !== null;

  const openHome = useCallback(() => router.replace(SMLRoutes.home), [router]);
  const signIn = useCallback(() => router.replace(SMLRoutes.auth), [router]);

  return (
    <PageUnavailable
      testId="page-not-found"
      icon={faCompass}
      title={intl.formatMessage(notFoundMessages.title)}
      text={intl.formatMessage(notFoundMessages.text)}
      primary={
        isSignedIn
          ? { label: intl.formatMessage(notFoundMessages.openHome), onClick: openHome }
          : { label: intl.formatMessage(notFoundMessages.signIn), onClick: signIn }
      }
    />
  );
};

export const NotFoundView = TypedMemo(NotFoundViewComponent);
